import React from 'react';
import { ArrowUpIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { SignupAudience } from '../../types/signup';
const panels: {
  audience: SignupAudience;
  title: string;
  body: string;
  cta: string;
  buttonClass: string;
}[] = [{
  audience: 'gigs',
  title: 'Got a phone? You’re hired.',
  body: 'Be first in line when gigs open in your city.',
  cta: 'Join as a tasker',
  buttonClass: 'bg-accent text-accent-ink'
}, {
  audience: 'company',
  title: 'Need eyes somewhere far?',
  body: 'Your first task is on us during early access.',
  cta: 'Request early access',
  buttonClass: 'bg-ink text-canvas'
}];
export function LandingCta({
  onSignup
}: {
  onSignup: (a: SignupAudience) => void;
}) {
  return <section className="mx-auto max-w-6xl px-6 pb-24" data-id="element-106" data-mp="1o4pjcmuqs0fz">
      <div className="grid gap-px overflow-hidden rounded-3xl border border-line bg-line md:grid-cols-2" data-id="element-107" data-mp="8kt6huzanffd">
        {panels.map((p, i) => <Reveal key={p.audience} delay={i * 0.06} className="flex flex-col bg-canvas p-8 md:p-12" data-id="element-108" data-mp="cld4f0royn2k" data-mpi={i}>
            <h2 className="font-display text-3xl font-semibold tracking-tight" data-id="element-109" data-mp="2045r2yad7ju2">{p.title}</h2>
            <p className="mt-3 text-muted" data-id="element-110" data-mp="1v5cdl5v2vstw">{p.body}</p>
            <div className="mt-auto pt-10" data-id="element-111" data-mp="294294h291kg5">
              <button onClick={() => onSignup(p.audience)} className={`group inline-flex items-center gap-2 whitespace-nowrap rounded-full px-6 py-3 font-medium transition-transform duration-150 ease-out active:scale-[0.97] ${p.buttonClass}`} data-id="element-112" data-mp="290wk11tmeikf">
                {p.cta}
                <ArrowUpIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:-translate-y-0.5" aria-hidden="true" data-id="element-113" data-mp="2sr081l7z412s" />
              </button>
            </div>
          </Reveal>)}
      </div>
    </section>;
}